import React, { useEffect, useState } from "react";
import { Card, Button } from "antd";
import moment from "moment";
import { ToWords } from "to-words";
import { RMGrnService } from "@gtpl/shared-services/raw-material-procurement";
import { GrnIdRequest } from "@gtpl/shared-models/procurement-management";
import logo from "../../../../../../../apps/ui/masters-ui/src/app/spsa logo.png";

const toWords = new ToWords({ localeCode: "en-IN" });

export interface BMRPrintProps {
  batchNumber: string;
  year: string;
  grnId: number;
}

export function RawMaterialGRNPrint(props: BMRPrintProps) {
  const service = new RMGrnService();

  const [data, setData] = useState<any[]>([]);
  const [summary, setSummary] = useState({
    totalQty: 0,
    totalAmount: 0,
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const res = await service.getRmGrnDataById(
      new GrnIdRequest(props.grnId)
    );

    if (res?.status) {
      const rows = res.data || [];
      setData(rows);

      let totalQty = 0;
      let totalAmount = 0;

      rows.forEach((item: any) => {
        const qty = Number(item.quantity || 0);
        const price = Number(item.price || 0);

        totalQty += qty;
        totalAmount += qty * price;
      });

      setSummary({ totalQty, totalAmount });
    }
  };

const printPage = () => {
  const content = document.getElementById("print-area");

  if (!content) return;

  const printWindow = window.open("", "", "width=900,height=650");

  if (printWindow) {
    printWindow.document.write(`
      <html>
        <head>
          <title>Voucher Print</title>
          <style>
            @page {
              size: A4;
              margin: 10mm;
            }

            body {
              margin: 0;
              padding: 0;
              font-family: Arial;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            img {
              max-width: 100%;
            }

            button {
              display: none !important;
            }

          </style>
        </head>
        <body>
          ${content.innerHTML}
        </body>
      </html>
    `);

    printWindow.document.close();

    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }, 500);
  }
};

  const header = data?.length ? data[0] : null;

  const amountWords = toWords
    .convert(summary.totalAmount || 0)
    .toUpperCase();

  return (
    <Card
      title="RAW MATERIAL PURCHASE VOUCHER"
      extra={<Button onClick={printPage}>Print</Button>}
      style={{ maxWidth: 900, margin: "auto" }}
      headStyle={{ textAlign: "center", background: "#69c0ff" }}
    >
<div id="print-area" style={{ padding: 20, position: "relative" }}>
       <div
  style={{
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    opacity: 0.12, 
    zIndex: 0,
    pointerEvents: "none",
  }}
>
  <img
    src={logo}
    alt="watermark"
    style={{
      width: 600,   
      height: "auto",
    }}
  />
</div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <div>
            <img src={logo} alt="logo" style={{ height: 80 }} />
          </div>

          <div style={{ textAlign: "center" }}>
            <h2 style={{ margin: 0 }}>S.P.S.A SILKS PVT LTD</h2>
            <p style={{ margin: 0 }}>Purchase Voucher</p>
          </div>

          <div
            style={{
              border: "1px solid #000",
              padding: "10px 15px",
              textAlign: "center",
              minWidth: 150,
            }}
          >
            <div style={{ fontSize: 12 }}>Voucher No</div>
            <hr style={{ margin: "5px 0" }} />
            <div style={{ fontWeight: "bold" }}>
              {header?.voucherNumber || "-"}
            </div>
          </div>
        </div>

        <table style={{ width: "100%", marginBottom: 20 }}>
          <tbody>
            <tr>
              <td>
                <b>RM Inward No:</b> {header?.grnNumber || "-"}
              </td>
              <td>
                <b>RM Inward Date:</b>{" "}
                {header?.indentDate
                  ? moment(header.indentDate).format("DD-MM-YYYY")
                  : "-"}
              </td>
            </tr>
          </tbody>
        </table>

        <div style={{ marginBottom: 20 }}>
          <p>
            <b>Paid To :</b> {header?.farmerName || "-"}
          </p>
        </div>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: 20,
          }}
        >
          <thead>
            <tr>
              <th style={th}>Product</th>
              <th style={th}>Total Qty (KGS)</th>
              <th style={th}>Price (₹)</th>
              <th style={th}>Total Amount (₹)</th>
            </tr>
          </thead>
          <tbody>
  {data.map((item, index) => {
    const qty = Number(item.quantity || 0);
    const price = Number(item.price || 0);
    const amount = qty * price;

    return (
      <tr key={index}>
        <td style={td}>{item.productName}</td>
        <td style={td}>{Number(Number(qty).toFixed(2))}</td>
        <td style={td}>{Number(Number(price).toFixed(2))}</td>
        <td style={td}>{Number(Number(amount).toFixed(2))}</td>
      </tr>
    );
  })}

  <tr>
    <td style={td}><b>Total</b></td>
    <td style={td}><b>{Number(Number(summary.totalQty || 0).toFixed(2))}</b></td>
    <td style={td}></td>
    <td style={td}><b>{Number(Number(summary.totalAmount || 0).toFixed(2))}</b></td>
  </tr>
</tbody>
        </table>

        <div style={{ marginBottom: 20 }}>
          <b>Amount in Words:</b> {amountWords} RUPEES ONLY
        </div>

        <table style={{ width: "100%", marginTop: 60 }}>
  <tbody>
    <tr>
      {/* <td style={signTd}>______________________</td>
      <td style={signTd}>______________________</td>
      <td style={signTd}>______________________</td> */}
      <td style={signTd}></td>
      <td style={signTd}></td>
      <td style={signTd}></td>
    </tr>

    <tr>
      <td style={signTd}>Prepared By</td>
      <td style={signTd}>Verified By</td>
      <td style={signTd}>Authorized Signatory</td>
    </tr>
  </tbody>
</table>

      </div>
    </Card>
  );
}

const th = {
  border: "1px solid black",
  padding: 10,
  background: "#fafafa",
};

const td = {
  border: "1px solid black",
  padding: 10,
  textAlign: "center" as const,
};
const signTd = {
  width: "33.33%",        
  textAlign: "center" as const,
  paddingTop: 20,
};